import {Component, computed, inject} from '@angular/core'
import {
  MatExpansionPanel,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion'
import {LoanService} from '../../../services/loan.service'
import {NoteItemComponent} from './note-item/note-item.component'

@Component({
  selector: 'spb-kalp-logs',
  templateUrl: './kalp-logs.component.html',
  styleUrls: ['./kalp-logs.component.scss'],
  imports: [MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, NoteItemComponent]
})
export class KalpLogsComponent {
  public notesLogs = computed(() =>
    this.logs().filter(l => l.type !== 'change')
  )

  public changesLog = computed(() =>
    this.logs().filter(l => l.type === 'change')
  )

  public numberOfChanges = computed(() => this.changesLog().length)

  private readonly loanService = inject(LoanService)

  private readonly logs = computed(() => {
    const application = this.loanService.application()
    if (application) {
      // Sort by date, the oldest on top
      const logs = [...(application.logs || [])]
      logs.sort((a, b) => b.date - a.date)
      return logs
    }
    return []
  })
}
